import React, { Fragment, useContext, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";

import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { Calendar } from "primereact/calendar";
import { locale, addLocale } from "primereact/api";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/DialogDemo.css";

addLocale("es", {
  firstDayOfWeek: 1,
  dayNames: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  monthNamesShort: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ],
  today: "Hoy",
  clear: "Limpiar",
});
locale("es");

export default function TomaAzul() {
  const minDate = new Date();

  const { tomaAzul, guardarTomaAzul, guardarDirecciones } =
    useContext(ServiciosContext);
  const { tiposMoviles, obtenerTiposMoviles } = useContext(ConfiguracionContext);

  useEffect(() => {
    obtenerTiposMoviles();
    guardarDirecciones([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Leer tecla y foco (Enter avanza, Esc retrocede).
  function handleEnter(event) {
    if (event.keyCode === 13) {
      let campo = null;
      switch (event.target.id) {
        case "llegada":
          campo = document.getElementById("tiposMoviles");
          if (campo) campo.focus();
          break;
        case "tiposMoviles":
          campo = document.getElementById("prestador");
          if (campo) campo.focus();
          break;
        case "prestador":
          campo = document.getElementById("provinciaAzul");
          if (campo) campo.focus();
          break;
        case "provinciaAzul":
          campo = document.getElementById("destinoAzul");
          if (campo) campo.focus();
          break;
        default:
          break;
      }
    }

    if (event.keyCode === 27) {
      let campo = null;
      switch (event.target.id) {
        case "destinoAzul":
          campo = document.getElementById("provinciaAzul");
          if (campo) campo.focus();
          break;
        case "provinciaAzul":
          campo = document.getElementById("prestador");
          if (campo) campo.focus();
          break;
        case "prestador":
          campo = document.getElementById("tiposMoviles");
          if (campo) campo.focus();
          break;
        case "tiposMoviles":
          campo = document.getElementById("llegada");
          if (campo) campo.focus();
          break;
        default:
          break;
      }
    }
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            variant="caption"
            color="text.secondary"
            component="div"
            sx={{ mb: 0.5 }}
          >
            Llegada *
          </Typography>
          <Calendar
            id="llegada"
            dateFormat="dd/mm/yy"
            selectionMode="multiple"
            locale="es"
            minDate={minDate}
            value={tomaAzul ? tomaAzul.llegada : null}
            baseZIndex={5001}
            appendTo={typeof document !== "undefined" ? document.body : null}
            touchUI
            showTime
            required
            showButtonBar
            placeholder="dd/mm/aaaa hh:mm"
            style={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            onChange={(e) =>
              guardarTomaAzul({ ...tomaAzul, llegada: e.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            id="tiposMoviles"
            fullWidth
            disablePortal
            required
            options={tiposMoviles}
            onKeyDown={handleEnter}
            defaultValue={
              tomaAzul && tomaAzul.tipoId !== undefined
                ? tiposMoviles[
                    tiposMoviles.findIndex((tipo) => tipo.id === tomaAzul.tipoId)
                  ]
                : null
            }
            getOptionLabel={(option) => option.nombre}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo de móvil"
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            )}
            onChange={(event, value) => {
              guardarTomaAzul({
                ...tomaAzul,
                tipoId: value ? value.id : null,
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="prestador"
            label="Prestador a asignar"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={tomaAzul ? tomaAzul.prestador : null}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaAzul({ ...tomaAzul, prestador: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            id="provinciaAzul"
            label="Provincia"
            value={tomaAzul ? tomaAzul.provincia : null}
            required
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            onKeyDown={handleEnter}
            onChange={(e) =>
              guardarTomaAzul({ ...tomaAzul, provincia: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={8}>
          <TextField
            id="destinoAzul"
            label="Destino"
            value={tomaAzul ? tomaAzul.destino : null}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            onKeyDown={handleEnter}
            disabled={tomaAzul && tomaAzul.destino === "Desconocido"}
            onChange={(e) =>
              guardarTomaAzul({ ...tomaAzul, destino: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                id="desconocido"
                color="primary"
                checked={tomaAzul ? tomaAzul.desconocido : false}
                onChange={(e) => {
                  guardarTomaAzul({
                    ...tomaAzul,
                    desconocido: e.target.checked,
                    destino: e.target.checked ? "Desconocido" : "",
                  });
                }}
              />
            }
            label="Destino desconocido"
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}
